import { Card, Typography } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import type { TopProducer } from "../../types/adjacent-crop";

const { Title } = Typography;

interface Props {
  data: TopProducer[];
  loading?: boolean;
}

export const TopProducersChart = ({ data, loading }: Props) => {
  // Take top 10 producers
  const chartData = data.slice(0, 10).map((item) => ({
    producer: item.producer_name,
    count: item.count,
    surface: item.total_surface,
  }));

  return (
    <Card loading={loading}>
      <Title level={5}>Top 10 Productores con Más Cultivos Adyacentes</Title>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={chartData} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="producer" type="category" width={150} />
          <Tooltip />
          <Bar dataKey="count" fill="#1890ff" name="Cantidad de Cultivos" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
